export default "__VITE_ASSET__Bq06kZQO__"